export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_8.f3dc18ef.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};